import { render, staticRenderFns } from "./caixasMesasDiaria.vue?vue&type=template&id=39ff73cc&scoped=true&"
import script from "./caixasMesasDiaria.vue?vue&type=script&lang=js&"
export * from "./caixasMesasDiaria.vue?vue&type=script&lang=js&"
import style0 from "./caixasMesasDiaria.vue?vue&type=style&index=0&id=39ff73cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ff73cc",
  null
  
)

export default component.exports